/**
 * Angaben zum Betreiber und zum Dienst für Impressum, FAQ und Blacklist-Seite.
 * Übernommen von der bisherigen Seite anonmails.de - bei Änderungen hier anpassen.
 */
export const site = {
  name: 'anonmails.de',
  operator: {
    name: 'Chi Kien Uong',
    street: 'Geranienstr. 30',
    city: '71034 Böblingen',
    country: { de: 'Deutschland', en: 'Germany' },
    email: 'chi.kien@uong.net',
  },
  /** POP3-Server für E-Mail-Programme (FAQ) */
  pop3Host: 'anonmails.de',
  /** Größenbeschränkungen (FAQ), müssen zu Postfix/Dovecot-Quota passen */
  maxMessageMb: 5,
  quotaMb: 30,
  dnsblZone: 'spam.dnsbl.anonmails.de',
  /**
   * Matomo-Webanalyse. url leer lassen = kein Tracking.
   * Die Domain muss in der Content-Security-Policy (Nginx) erlaubt sein:
   * script-src und connect-src.
   */
  /**
   * Download auf der Blacklist-Seite (wie bisher anonmails.de/files/DNSBLCheck.zip).
   * Datei liegt in apps/web/public/files/ und wird beim Build nach dist/files/ kopiert.
   * Leer = Abschnitt ausgeblendet.
   */
  dnsblCheckDownload: '/files/DNSBLCheck.zip',
  /** PayPal-Spendenbutton auf der Startseite (hosted_button_id aus PayPal); leer = ausgeblendet */
  paypalDonateButtonId: '66BKN4NUXW3NU',
  matomo: {
    url: 'https://proxy2.de/pi/',
    siteId: '3',
    /** Ohne Cookies zählen (kein Cookie-Banner nötig, Besucher werden nicht wiedererkannt) */
    disableCookies: true,
  },
};
